import { Box, Flex, Text, Image } from "@chakra-ui/react";
import Button from "../../components/Button";

function ErrorPage() {
  const refreshPage = () => {
    window.location.reload();
  };
  const previousPage = () => {
    window.location.href = "/login";
  };

  return (
    <Flex
      w={"100%"}
      height={"100%"}
      display={"flex"}
      flexDir={"column"}
    >
      <Box pl={{ base: "1rem", md: "5rem" }}>
        <Image
          alt="logo"
          src="/icons/weddnlogo.svg"
          w={{ base: "150px", md: "160px" }}
        />
      </Box>
      <Flex
        alignItems={"center"}
        justifyContent={"space-evenly"}
        display={{ base: "column", md: "flex" }}
      >
        <Flex>
          <Box
            px={"10px"}
            pt={{ base: "2rem", md: "5rem" }}
            display={"flex"}
            flexDir={"column"}
            alignItems={"center"}
            justifyContent={"center"}
          >
            <Flex
              py={"20px"}
              gap={"15px"}
              flexDir={"column"}
              textAlign={"left"}
            >
              <Text
                fontWeight={"600"}
                fontSize={{ base: "2rem", md: "3rem" }}
                fontFamily={"Gilda Display"}
              >
                Ooops!
              </Text>
              <Text
                fontWeight={"600"}
                fontSize={{ base: "14px", md: "20px" }}
              >
                We're not sure how you got here... but you may be
                lost.
              </Text>

              <Text
                fontWeight={"600"}
                fontSize={{ base: "14px", md: "22px" }}
              >
                Possible Reasons
              </Text>
              <Text
                pl={"20px"}
                fontSize={{ base: "14px", md: "17px" }}
              >
                <ul>
                  <li>The address may have been typed incorrectly</li>
                  <li>It may be broken or outdated</li>
                </ul>
              </Text>

              <Text
                fontSize={{ base: "14px", md: "22px" }}
                fontWeight={"600"}
              >
                <p>
                  Check the address and try again
                </p>
              </Text>

              <Flex pt={'1rem'}>
                <Button
                  text={"Go back"}
                  w={{ base: "100px", md: "140px" }}
                  onClick={previousPage}
                />
                <Button
                  color={"rgb(76, 144, 99)"}
                  fontSize={"1.125rem"}
                  fontWeight={600}
                  w={{ base: "100px", md: "140px" }}
                  bg={"transparent"}
                  text={"Retry"}
                  hover={"transparent"}
                  onClick={refreshPage}
                />
              </Flex>
            </Flex>
          </Box>
        </Flex>
        <Flex pt={"8rem"} display={{ base: "none", md: "flex" }}>
          <Image
            alt="logo"
            src="/images/error.svg"
            w={{ base: "250px", md: "450px" }}
          />
        </Flex>
      </Flex>
    </Flex>
  );
}

export default ErrorPage;
